module.exports = __webpack_public_path__ + "img/index_map_bg.be1ea9aa.jpg";